import { fetchV3WithTranslateServerErrors, getOrderFlowHeaders } from './base';
import { EVENT_DEFAULT_ERROR_MESSAGE } from '../constants';
import { getTokens } from '../actions/tokens';
import { _getLogoutUrl } from './constants';

/**
 * How to handle errors on the event lifecycle
 */
const ERROR_SPEC = {
    default: () => EVENT_DEFAULT_ERROR_MESSAGE,
};

/**
 * Returns a `fetch` Promise to log the user out
 */
export const logout = () =>
    fetchV3WithTranslateServerErrors(ERROR_SPEC, _getLogoutUrl(), {
        method: 'POST',
        headers: getOrderFlowHeaders(getTokens()),
    });
